
import styles from './toolbar.module.css';

import LocationSearch from "./LocationSearch";
import CheckboxFiliter from "./CheckboxFilter";
import { WithSearch } from "@elastic/react-search-ui";

import logEvent from "lib/ga/miscEvent";
import AdvancedFiliters from "../AdvancedFiliters";
import SizeFiliterType from "./SizeFiliter";
import MinMaxFilter from "./MinMaxFilter"

type PageProps = {
  filters?: any;
  facets?: any;
  addFilter?: any;
  setFilter?: any;
  removeFilter?: any;
  location: string;
  defaultRent: number;
  defaultSizeFt: number;
  defaultSizeM: number;
  isPortfolioPage: boolean;
  type: string;
  searchCriteria: string;
  hideLocationSearch?: boolean;
  sizeMeasurementType: any;
  setSizeMeasurementType: any;
  sizeTypes: any;
  defaultPrice: any;
  includeDefaultOptions?: any;
  category_code?: any;
  forSale?: boolean;
  showAdvancedFilters: boolean;
  onShowAdvancedFilters: any;
};

const Toolbar = ({ searchCriteria, type, facets, filters, includeDefaultOptions = true, category_code, addFilter, setFilter, removeFilter,
  hideLocationSearch = false, location, defaultRent, defaultSizeFt, defaultSizeM, isPortfolioPage, sizeMeasurementType,
  setSizeMeasurementType, sizeTypes, forSale, defaultPrice, showAdvancedFilters, onShowAdvancedFilters }: PageProps) => {
  
    const setShowAdvancedFilters = () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
  
      if ('showAdvancedFilters' in params) {
        delete params['showAdvancedFilters'];
      } else {
        params['showAdvancedFilters'] = 'true';
      }
  
      let data = {
        ...params
      }
  
      let convert = new URLSearchParams(data).toString()
      const newPath = `${window.location.pathname}?${convert}`;
      window.history.replaceState({ ...window.history.state, as: newPath, url: newPath }, '', newPath)
    }

  const hideLocation = hideLocationSearch || searchCriteria === 'COMPANY';

  return (
    <div className={hideLocation ? `${styles.overviewLayout} ${styles.ExternalContainer}` : styles.ExternalContainer} >
      <div className={hideLocation ? `${styles.insideContainerOverviewLayout} ${styles.mobileHide} ${styles.insideContainer}` : styles.insideContainer}>
        {!hideLocationSearch && searchCriteria !== 'COMPANY' && (
          <div>
            <div className={styles.sizeFilterHeader}>
              <p>Location</p>
            </div>
            <LocationSearch currentLocation={location} isPortfolioPage={isPortfolioPage} type={type} forSale={forSale} />

          </div>
        )}

        <div>
          <div className={styles.sizeFilterHeader}>
            <p>Size</p>

            <SizeFiliterType
              sizeTypes={sizeTypes}
              setSizeMeasurementType={setSizeMeasurementType}
              removeFilter={removeFilter}
              setFilter={setFilter}
              filters={filters}
              sizeValue={sizeMeasurementType?.value}
            />
          </div>
          <div className={styles.sizeFiliter}>
            <MinMaxFilter
              field={sizeMeasurementType.value}
              facetData={facets[`${sizeMeasurementType.value}_range`] ? facets[`${sizeMeasurementType.value}_range`][0].data : []} facetName={`${sizeMeasurementType.value}_range`} isPrice={false}
              addFilter={addFilter}
              filters={filters}
              setFilter={setFilter}
              removeFilter={removeFilter} additionalFields={[]}            />
          </div>
        </div>
        <div>

          {forSale && (
            <>
              <div className={styles.sizeFilterHeader}>
                <p>Price</p>
              </div>
              <div className={styles.sizeFiliter}>
                <MinMaxFilter
                  field={'price'}
                  facetData={facets[`price_range`] ? facets[`price_range`][0].data : []} facetName={`price_range`} isPrice={false}
                  addFilter={addFilter}
                  filters={filters}
                  setFilter={setFilter}
                  removeFilter={removeFilter} additionalFields={[]}                />
              </div>
            </>
          )}

          {!forSale && (
            <>
              <div className={styles.sizeFilterHeader}>
                <p>Rent</p>
                <CheckboxFiliter field="includePOA" label="Include POA" filters={filters} setFilter={setFilter} addFilter={addFilter}/>
              </div>
              <div className={styles.sizeFiliter}>
                <MinMaxFilter
                  field={'rent_pa'}
                  facetData={facets[`rent_pa_range`] ? facets[`rent_pa_range`][0].data : []} facetName={`rent_pa_range`} isPrice={false}
                  addFilter={addFilter}
                  filters={filters}
                  setFilter={setFilter}
                  removeFilter={removeFilter} additionalFields={[]}                />
              </div>
            </>
          )}

        </div>
      </div>

      <div className={styles.allFilters}>
        <button className={showAdvancedFilters ? `${styles.active} ${styles.buttonTopBar}` : styles.buttonTopBar} onClick={(e) => {
          setShowAdvancedFilters();
          onShowAdvancedFilters(!showAdvancedFilters)
          logEvent({
            category: "Schemes Search UI",
            action: "Change view type",
            label: 'All filters',
          });
        }}
        >

          <picture>
            <source media="(prefers-color-scheme: dark)" srcSet={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/dark/all-filiters.svg`} />
            <img className="light" src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/all-filiters.svg`}
              width="20" height="20" alt="All filters" />
          </picture>

          All filters</button>
      </div>


      <AdvancedFiliters
        showAdvancedFilters={showAdvancedFilters}
        location={location}
        defaultRent={defaultRent}
        defaultSizeFt={defaultSizeFt}
        defaultSizeM={defaultSizeM}
        sizeType={sizeMeasurementType}
        sizeTypes={sizeTypes}
        sizeMeasurementType={sizeMeasurementType}
        setSizeMeasurementType={setSizeMeasurementType}
        forSale={forSale}
        defaultPrice={defaultPrice}
        includeDefaultOptions={includeDefaultOptions}
        category_code={category_code} 
        removeFilter={undefined} 
        clearFilters={undefined}      />
    </div >
  )
}

const ToolbarWithSearch = ({ ...props }: PageProps) => {
  return <WithSearch mapContextToProps={({ filters, clearFilters, addFilter, setFilter, removeFilter, facets, ...rest }) => ({
    filters, clearFilters, addFilter, setFilter,
    removeFilter, facets, rest, ...props
  })}>
    {(props) => {
      return <Toolbar {...props} />
    }}
  </WithSearch>
}

export default ToolbarWithSearch;
